import {TradeNameColumnsDef} from '@/modules/products/trade-names/components'
import {openTradeNameDrawer} from '@/modules/products/trade-names/components/trade-name-drawer/util'
import {InfiniteDataTableV2, type InfiniteDataTableV2Props} from '@cypro/ui/components/ui/infinite-data-table'
import {TradeName} from '@cypro/engine/schema'
import {useTranslate} from '@tolgee/react'
import {useMemo, useCallback} from 'react'
import {LuPill} from 'react-icons/lu'
import {useRouter} from '@tanstack/react-router'

// oxlint-disable-next-line typescript/no-empty-object-type
interface Props<TStartRow> extends Omit<InfiniteDataTableV2Props<TradeName, TStartRow>, 'emptyState' | 'columns'> {}

export function TradeNamesTable<TStartRow>({table: tableConfig, virtualizer: virtualizerConfig, ...rest}: Props<TStartRow>) {
  const {t} = useTranslate('common')
  const router = useRouter()

  const getRowUrl = useCallback(
    (row: TradeName | undefined) => {
      if (!row) return
      return router.buildLocation({to: '/configuration/products/trade-names/new', search: {tradeNameId: row.id}}).href
    },
    [router]
  )

  const columns = useMemo(
    () => [
      TradeNameColumnsDef.viewPage({maxSize: 7}),
      TradeNameColumnsDef.name({maxSize: 30}),
      TradeNameColumnsDef.substances({maxSize: 23}),
      TradeNameColumnsDef.type({maxSize: 23}),
      TradeNameColumnsDef.form({maxSize: 15}),
      TradeNameColumnsDef.status({maxSize: 10}),
    ],
    []
  )

  return (
    <InfiniteDataTableV2<TradeName, TStartRow>
      {...rest}
      table={{
        ...tableConfig,
        columns,
        meta: {...tableConfig.meta, getRowUrl},
      }}
      virtualizer={virtualizerConfig}
      emptyState={{
        title: t('no_trade_names'),
        description: t('create_new_trade_name_to_get_started'),
        icon: LuPill,
      }}
      onRowClick={openTradeNameDrawer}
    />
  )
}
